import { useContext } from 'react';
import { EMPTY_OBJECT, AppContext, UserContext } from 'commons-ui';

import useService from '../utils/useService';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog } = params;
	const { app, showAlert } = useContext(AppContext);
	const { user } = useContext(UserContext);
	const { toggleIsDisabledField } = useService();

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/coupon/edit',
					state: {
						rowData
					}
				});
			};
		case 'clone':
			return () => {
				history.push({
					pathname: '/dashboard/coupon/clone',
					state: {
						rowData
					}
				});
			};
		case 'conversions':
			return () => {
				history.push({
					pathname: '/dashboard/coupon/payoutDetails',
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: '/dashboard/coupon/create'
				});
			};
		case 'back':
			return () => {
				history.push({
					pathname: '/dashboard/coupon/list'
				});
			};
		case 'deploy': {
			const toggleIsDisabled = () => {
				return toggleIsDisabledField(rowData, history, user, app, showAlert);
			};

			const { isDisabled } = rowData;
			return () => {
				setConfirmationDialog({
					show: true,
					header: isDisabled ? 'Deploy on app?' : 'Remove from app?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}

		case 'remove': {
			const toggleIsDisabled = () => {
				return toggleIsDisabledField(rowData, history, user, app, showAlert);
			};

			const { isDisabled } = rowData;
			return () => {
				setConfirmationDialog({
					show: true,
					header: isDisabled ? 'Deploy on app?' : 'Remove from app?',
					handleAlertConfirmation: toggleIsDisabled
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
